import { ValidationError } from 'yup';
export function validateMessageAndThrow(schema, message, path) {
    try {
        if (path) {
            schema.validateSyncAt(path, message, { abortEarly: false });
        }
        else {
            schema.validateSync(message, { abortEarly: false });
        }
    }
    catch (ex) {
        if (!(ex instanceof ValidationError)) {
            throw new Error('Not a validation error', { cause: ex });
        }
        throw ex;
        // TODO: (later) add error log to backend.
        // console.log('Signalr message validation errors: ', ex.errors);
    }
}
